import { Exclude, Expose } from 'class-transformer';
import { BasePersonnelModel } from './personnel.model';
import { Method, PersonnelAppointment, UniqueArray } from '@core/data-access';
import { DeepPartial, Default } from '@core/util';

@Exclude()
export class UsPersonModel extends BasePersonnelModel {
  /**
   * Using in Dropdown
   */
  @Expose({ toClassOnly: true }) @Default(null) uuid!: string | null;

  /**
   * Using for patching self data instead of using CorpPass Personnel
   */
  @Expose({ toClassOnly: true }) @Default(null) self!: DeepPartial<InstanceType<typeof UsPersonModel>> | null;

  /**
   * Using to Show/Hide Form Field
   */
  @Expose({ toClassOnly: true }) @Default(Method.manual) method!: Method | null;

  @Expose() keyPersonnelId!: number | null;

  @Expose() @Default([]) @UniqueArray() appointment!: PersonnelAppointment[];

  @Expose() share!: number;

  @Expose() usCitizenTaxNumber!: string;
}
